import creditEngineRepository, {CreditEngineRepository} from "./CreditEngineRepository"
import EzUtils from "@/utils/EzUtils";

const resource = "/partner";
export default {

  getRetailerConfig(partnerConfigRequest) {
    creditEngineRepository.setContentType("application/json");
    return CreditEngineRepository.post(`${resource}/config`, partnerConfigRequest);
  },

  getPublicRetailerConfig(partnerConfigRequest, leadId) {
    creditEngineRepository.setContentType("application/json");
    let url = `${resource}/public/config`;
    if (EzUtils.isValidId(leadId)) {
      url = url + "?leadId=" + leadId;
    }
    return CreditEngineRepository.post(url, partnerConfigRequest);
  }
}
